interface TagProps {
  children: React.ReactNode;
}

export default function Tag({ children }: TagProps) {
  return (
    <span className="inline-flex items-center rounded-full bg-secondary-100 px-2.5 py-1 font-label text-xs text-secondary-900 whitespace-nowrap">
      {children}
    </span>
  );
}